import { swap } from '@/utils/utils'
import toast from '@/utils/toast'
import store from './index'
export default {
    mutations: {
        upComponent({ componentData, curComponentIndex }) {
            if (store.state.clickIndex !== null && store.state.clickIndex > 0) {
                swap(componentData, store.state.clickIndex + 1, store.state.clickIndex - 1)
                store.state.clickIndex = store.state.clickIndex - 1
            } else if (curComponentIndex > 0) {
                swap(componentData, curComponentIndex + 1, curComponentIndex - 1)
                store.state.curComponentIndex = curComponentIndex - 1
            } else {
                toast('已经到顶了')
            }
            componentData.forEach((e, index) => { e.FormOrder = index })
        },

        downComponent({ componentData, curComponentIndex }) {
            // 下移图层 index，表示元素在数组中越往前
            if (store.state.clickIndex !== null && store.state.clickIndex < store.state.componentData.length - 1) {
                swap(componentData, store.state.clickIndex + 2, store.state.clickIndex)
                store.state.clickIndex = store.state.clickIndex + 1
            } else if (curComponentIndex < componentData.length - 1) {
                swap(componentData, curComponentIndex + 2, curComponentIndex)
                store.state.curComponentIndex = curComponentIndex + 1
            } else {
                toast('已经到底了')
            }
            componentData.forEach((e, index) => { e.FormOrder = index })
        },

        topComponent({ componentData, curComponentIndex }) {
            // 置顶
            if (curComponentIndex < componentData.length - 1) {
                swap(componentData, curComponentIndex, componentData.length - 1)
            } else {
                toast('已经到顶了')
            }
        },

        bottomComponent({ componentData, curComponentIndex }) {
            // 置底
            if (curComponentIndex > 0) {
                swap(componentData, curComponentIndex, 0)
            } else {
                toast('已经到底了')
            }
        },
    },
}


// WEBPACK FOOTER //
// ./src/store/layer.js